// extracted by mini-css-extract-plugin
module.exports = {"warningList":"style_warningList__1HUC6"};